module.exports = {
      id: "cancel-usage",
      viewBox: "0 0 241.171 241.171",
      url: "/" + "sprite-4add775381efce29ef76f223dff77c00.svg#cancel",
      toString: function () {
        return this.url;
      }
    }